import { render } from "./SelectionMenuStep3.vue?vue&type=template&id=9c7da4c8&scoped=true"
import script from "./SelectionMenuStep3.vue?vue&type=script&lang=ts"
export * from "./SelectionMenuStep3.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-9c7da4c8"

export default script